import { SxProps, Theme } from '@mui/material';

export const BenefitsGrayFrameSX: SxProps = {
	background: '#F1F1F1',
};

export const BenefitsGrayContentSX: SxProps<Theme> = (theme) => ({
	display: 'flex',
	justifyContent: 'space-between',
	alignItems: 'center',
	maxWidth: '1071px',
	flexDirection: 'row',
	overflowX: 'auto',
	[theme.breakpoints.down('md')]: {
		flexWrap: 'wrap',
		justifyContent: 'center',
	},
});

export const BenefitsGraySlideInnerSX: SxProps<Theme> = () => ({
	'& .carousel__inner-slide': {
		display: 'flex',
		justifyContent: 'center',
	},
});

export const BenefitsGrayItemSX: SxProps = {
	width: 'fit-content',
	maxWidth: '160px',
	justifyContent: 'flex-start',
	alignItems: 'center',
	display: 'flex',
	gap: '5px',
	cursor: 'pointer',
};

export const BenefitsGrayTitleSX: SxProps<Theme> = () => ({
	color: '#2C2C2C',
	fontSize: 'var(--font-size-default)',
	textAlign: 'center',
});

export const BenefitsGrayDescriptionSX: SxProps<Theme> = {
	color: '#929292',
	fontSize: 'var(--font-size-small)',
	textAlign: 'center',
};
